module.exports = __webpack_public_path__ + "static/kamil_zielinski-5d6b89194df7fa1dfec68482c6c2a4ca.png";